interface Props {
  open: boolean;
  inkLeft: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export function EndSceneConfirm({ open, inkLeft, onCancel, onConfirm }: Props) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" role="dialog" aria-labelledby="end-scene-title" aria-modal="true">
      <div className="modal-card">
        <h2 id="end-scene-title">End scene anyway?</h2>
        <p>
          You still have {inkLeft} Ink and cards you can play. End scene moves on without spending them.
          Playing cards is separate from ending the scene.
        </p>
        <div className="modal-actions">
          <button type="button" className="btn btn-primary" onClick={onCancel}>
            Keep playing
          </button>
          <button type="button" className="btn btn-secondary" onClick={onConfirm}>
            End scene
          </button>
        </div>
      </div>
    </div>
  );
}
